<template>
  <div class="animated fadeIn mb-3">
      <b-row >
      <b-col md="3" class="tabtext">
        <span ><b>Zip Code</b></span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span ><b>Quantity</b></span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span ><b>City</b></span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span ><b>State</b></span>
      </b-col>
      <b-col md="3" class="tabtext">
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <!-- <ul id="example-1">
          <li v-for="zip in zip.current_territory_zips" :key="zip.ZipCode">{{ zip.ZipCode }}</li>
        </ul>-->
        <RotationZipRow 
          v-for="zip in current_rotation.RotationZips"
          :key="zip.ZipCode"
          :rotation_object="current_rotation"
          :zip_object="zip"
        />
      </b-col>
    </b-row>
     <b-row class="mt-2">
      <b-col lg="12">
        <!-- <ul id="example-1">
          <li v-for="zip in zip.current_territory_zips" :key="zip.ZipCode">{{ zip.ZipCode }}</li>
        </ul>-->
        <RotationZipRow
          :rotation_object="current_rotation"
           :zip_object= "blank_zip" 
          v-bind:is_new="true"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import RotationZipRow from "@/components/CustomRowComponents/RotationZipRow.vue";


export default {
  name: "RotationZipEditor",
  props: {
    rotation_object: { type: Object },
  },
  components: { RotationZipRow },
  data() {
    return {
      current_rotation: this.rotation_object,
      blank_zip: {ZipCode: ''}
    };
  },
  computed: {
    ...mapState(["seminar", "territory", "zip", "n_user"]),
  },
  methods: {
   
  },
  created() {
    
  },
  watch: {
     current_rotation: function (newValue, oldValue) {
    },
  },
};
</script>

<style lang="scss" scoped>
</style>